import { render, staticRenderFns } from "./FileOptions.vue?vue&type=template&id=082ecfe9&"
import script from "./FileOptions.vue?vue&type=script&lang=js&"
export * from "./FileOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('082ecfe9')) {
      api.createRecord('082ecfe9', component.options)
    } else {
      api.reload('082ecfe9', component.options)
    }
    module.hot.accept("./FileOptions.vue?vue&type=template&id=082ecfe9&", function () {
      api.rerender('082ecfe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/FileOptions.vue"
export default component.exports